import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { adminLogin } from "../../lib/adminApi";
import { setAdminToken } from "../../lib/adminAuth";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { token } = await adminLogin(password);
      setAdminToken(token);
      navigate("/admin/programs", { replace: true });
    } catch {
      setError("Giriş başarısız. Şifreyi kontrol edin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--tv-bg)] flex items-center justify-center px-5">
      <form onSubmit={submit} className="tv-card w-full max-w-md p-8 space-y-5">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-[rgba(139,92,246,0.15)] border border-[var(--tv-border)] flex items-center justify-center">
            <Lock size={20} className="text-[var(--tv-purple-bright)]" />
          </div>
          <div>
            <h1 className="font-display font-bold text-xl text-white">TV13 Admin</h1>
            <p className="text-sm text-[var(--tv-muted)]">Yönetim paneline giriş</p>
          </div>
        </div>

        <div>
          <label className="text-sm text-[var(--tv-muted)] mb-1.5 block">Şifre</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="tv-input"
            placeholder="Admin şifresi"
            autoFocus
          />
        </div>

        {error && <p className="text-sm text-red-400">{error}</p>}

        <button type="submit" disabled={loading} className="tv-btn-primary w-full">
          {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
        </button>

        <p className="text-xs text-[var(--tv-muted)] text-center">
          Varsayılan yerel şifre: <code className="text-white/80">tv13admin</code>
        </p>
      </form>
    </div>
  );
}
